import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function IndustryOption({ values }) {
  const [allSkills, setAllSkills] = useState([]);
  const { state, setIndustries } = useAllFilterBaseContext();
  const { industries } = state;

  useEffect(() => {
    setAllSkills(values);
  }, [values]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    const updatedSkills = [...industries, newLanguage];
    setIndustries(updatedSkills);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = industries.filter(
      (language) => language.id !== id,
    );
    setIndustries(updatedLanguages);
  };

  return (
    <div>
      <ReactSelect
        options={
          Array.isArray(allSkills) &&
          allSkills
            .filter((lang) => {
              return (
                Array.isArray(industries) &&
                !industries.some(
                  (selectedLang) => selectedLang.id === lang.id,
                )
              );
            })
            .map((lang) => ({ value: lang.id, label: lang.title }))
        }
        placeholder="Search Here fg"
        isClearable={true}
        value={[]}
        onChange={(options) => {
          if (options) {
            handleLanguageChange(options);
          }
        }}
      />

      <div className="add-skills">
        {Array.isArray(industries) &&
          industries.map((skills, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skills.id)}>
                {skills.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
